import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ImportMasterService } from "src/app/services/import-master.service";
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  selector: "app-secure-import-master",
  templateUrl: "./import-master.component.html",
  styleUrls: ["./import-master.component.scss"],
})
export class ImportMasterComponent implements OnInit {
  isLoading = false;
  lotteries: {[key: number]: string};
  uploadMasterTypes: string[];
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  selectedFile: File;
  successMessage: string;
  errorMessage: String;
  errorFile: string;
  @ViewChild('localForm') localForm : NgForm;

  constructor(
    private router: Router,
    private importMasterService: ImportMasterService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.loadData();

    this.form = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      importMasterType: new FormControl("", Validators.required),
      file: new FormControl(null, Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.importMasterService.initImportMasterForm().subscribe((data) => {
        if(data.status === 'SUCCESS') {
          this.lotteries = data.lotteries;
          this.uploadMasterTypes = data.uploadMasterTypes;
        }
        else {
          this.importMasterService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.importMasterService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit() {
    if (this.form.valid) {
      this.successMessage = null;
      this.errorMessage = null;
      this.errorFile = null;

      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.importMasterService
        .importMaster(
          this.form.value.lotteryKey.key, 
          this.form.value.importMasterType,
          reader.result
        )
        .subscribe((data: any) => {
          this.isSubmitDisabled = false;
          if(data.status === 'SUCCESS') {
            this.successMessage = "Successfully imported "+this.form.value.importMasterType+": "+data.successCount;
            this.localForm.resetForm({
              lotteryKey: "",
              importMasterType: "",
              file: null
            });
            this.selectedFile = null;
          }
          else {
            this.localForm.resetForm({
              lotteryKey: this.form.value.lotteryKey,
              importMasterType: this.form.value.importMasterType,
              file: null
            });
            this.selectedFile = null;
            this.errorMessage = "Failed to import, Please check error file.";
            this.errorFile = data.errorFile;
          }
        }, error => {
          this.localForm.resetForm({
            lotteryKey: "",
            importMasterType: "",
            file: null
          });
          this.selectedFile = null;
          this.isSubmitDisabled = false;
          console.log(error);
          this.importMasterService.errorToast(error?.error?.message||error?.error?.errorMessage, 5*1000);
        });
      };      
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  downloadTemplate() {
    if(this.form.value.importMasterType) {
      this.importMasterService
      .downloadTemplate(
        this.form.value.importMasterType
      )
      .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.data, this.form.value.importMasterType+".csv");
        }
        else {
          this.importMasterService.errorToast(data.errorMessage);
        }
      });
    }
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `data:text/csv;base64,${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

  sanitizeUrl(preUrl: string) {
    return this.domSanitizer.bypassSecurityTrustUrl("data:text/csv;base64," + preUrl);
  }
}